var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopCharts"},[_c('div',{staticClass:"left"},[_c('PublicEcharts',{attrs:{"id":"topChartsLeft","chartsData":_vm.orderDataLeft,"options":_vm.dealRingData(),"usePropsOptions":""}})],1),_c('div',{staticClass:"right"},[_c('PublicEcharts',{attrs:{"id":"topChartsRight","options":_vm.dealOptionRight(),"usePropsOptions":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }